export default __webpack_public_path__ + "assets/images/7ab6a5bfab1f162eea1b3c6cf4bc98ad.svg";